import Config from '../Config';

export default (store) => (next) => (action) => {
  if (action.type === 'ADD_UPDATE_ICONTENT_ITEM' && /\b404\b/.test(action.item?.error?.value)) {
    window.location.pathname = Config.errorPageNotFound;
    return;
  }
  return next(action);
};
